import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { END } from './types';

export const playerEndAction = actionCreator(END);
